module.exports = __webpack_public_path__ + "img/about-image.fc98a693.jpg";